import { render, staticRenderFns } from "./ggAndAePc.vue?vue&type=template&id=1280d088&scoped=true"
import script from "./ggAndAePc.vue?vue&type=script&lang=js"
export * from "./ggAndAePc.vue?vue&type=script&lang=js"
import style0 from "./ggAndAePc.vue?vue&type=style&index=0&id=1280d088&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1280d088",
  null
  
)

export default component.exports